// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportDialog_container__MyKg3","comment__container":"ReportDialog_comment__container__t5cjy","commentContainer":"ReportDialog_comment__container__t5cjy"};